import { useQuery } from "react-query";
import { request } from "../utils/axios-utils";

const fetchAllCountryCodes = () => {
    return request({ url: "/countryCodes", method: "GET" });
};

const useCountryCodes = (onSuccess, select) => {
    return useQuery("countryCodes", fetchAllCountryCodes, {
        onSuccess: onSuccess ? onSuccess : null,
        select: select ? (data) => select(data.data) : (data) => data.data,
     });
};

export default useCountryCodes;
